export default __webpack_public_path__ + "static/media/fly.f9dfc4dd.svg";